const aboutBoxWrap = document.querySelectorAll('.js_aboutBoxWrap');
const aboutBox = {
	elms: document.querySelectorAll('.js_aboutBox'),
};
aboutBox.pos = aboutBox.elms[0].getBoundingClientRect().top + document.scrollingElement.scrollTop;
aboutBox.height = aboutBox.elms[0].offsetHeight;
const aboutContent = document.querySelectorAll('.js_aboutContent');
const aboutDummy = {
	parent: document.getElementById('aboutContent'),
};
const aboutObj = {
	padding: 0,
	pageLength: 0,
	itemPos: [],
};
const aboutSection = document.querySelector('.about');

for (let i = 0; i < aboutContent.length; i++) {
	if (i > 0) {
		aboutContent[i].style.transform = 'translateY(' + aboutObj.padding + aboutBox.elms[i].offsetHeight + 'px)';
	}
}

const paddingElm = document.createElement('div');
paddingElm.classList.add('dummyPadding');

const removeDummy = () => {
	const dummy = document.querySelectorAll('.dummy');
	for (let i = 0; i < dummy.length; i++) {
		aboutDummy.parent.removeChild(dummy[i]);
	}
}

const lengthChange = (init) => {
	aboutObj.pageLength = 0;
	aboutDummy.children = [];
	removeDummy();
	for (let i = 0; i < aboutContent.length; i++) {
		aboutObj.itemPos[i] = aboutObj.pageLength;
		aboutObj.pageLength += aboutContent[i].offsetHeight;
		aboutDummy.children[i] = document.createElement('div');
		aboutDummy.children[i].classList.add('dummy');
		aboutDummy.children[i].style.height = aboutContent[i].offsetHeight + 'px';
		aboutSection.insertAdjacentElement('beforebegin', aboutDummy.children[i]);
	}
	paddingElm.style.height = window.innerHeight - document.querySelector('.toTop').offsetHeight - document.querySelector('.footer').offsetHeight - aboutBox.height + 'px';
	aboutSection.insertAdjacentElement('beforebegin', paddingElm);
	if (init) {
		aboutDummy.parent.scrollTop = 0;
	}
};

lengthChange(1);
window.addEventListener('load', lengthChange, false);
window.addEventListener('resize', lengthChange, false);

const sc = ((elm) => {
	let scrollPoint, prePoint, flag;
	if (!elm) {
		elm = aboutDummy.parent;
	}
	return (elm) => {
		scrollPoint = elm.scrollTop;
		if (prePoint > scrollPoint) {
			flag = 'up';
		} else if (prePoint < scrollPoint) {
			flag = 'down';
		} else {
			flag = 'stay';
		}
		prePoint = scrollPoint;
		return flag;
	};
})();

const aboutScroll = () => {
	const scroll = aboutDummy.parent.scrollTop;
	const direction = sc(aboutDummy.parent);
	if (scroll === 0) {
		for (let i = 0; i < aboutBoxWrap.length; i++) {
			aboutBoxWrap[i].classList.remove('over', 'under', 'current');
		}
		aboutBoxWrap[0].classList.add('current');
		aboutContent[0].style.transform = 'translateY(0)';
		return;
	}
	for (let i = 0; i < aboutContent.length; i++) {
		const _scrollNum = aboutObj.itemPos[i] - scroll;
		const currentElm = aboutBoxWrap[i];
		const prevElm = (aboutBoxWrap[i - 1]) ? aboutBoxWrap[i - 1] : false;
		const nextElm = (aboutBoxWrap[i + 1]) ? aboutBoxWrap[i + 1] : false;
		aboutContent[i].style.transform = 'translateY(' + _scrollNum + 'px)';
		if (direction === 'down' && aboutObj.itemPos[i] + aboutContent[i].offsetHeight - 100 <= scroll) {
			if (currentElm.classList.contains('current') && i !== aboutBoxWrap.length - 1) {
				currentElm.classList.remove('current');
				currentElm.classList.add('over');
				if (nextElm) {
					nextElm.classList.add('current');
					nextElm.classList.remove('under');
				}
			}
		} else if (direction === 'up' && aboutObj.itemPos[i] - aboutObj.padding > scroll) {
			if (currentElm.classList.contains('current') && i !== 0) {
				currentElm.classList.remove('current');
				currentElm.classList.add('under');
				if (prevElm) {
					prevElm.classList.add('current');
					prevElm.classList.remove('over');
				}
			}
		}

		if (
			direction === 'down'
			&& i === aboutContent.length - 1
			&& aboutObj.itemPos[i] + aboutContent[i].offsetHeight <= scroll + aboutBox.height
		) {
			const diff = (aboutObj.itemPos[i] + aboutContent[i].offsetHeight) - (scroll + aboutBox.height);
			aboutSection.style.transform = 'translateY(' + diff + 'px)';
		} else if (
			direction === 'up'
			&& i === aboutContent.length - 1
			&& aboutObj.itemPos[i] <= scroll
		) {
			let diff = (aboutObj.itemPos[i] + aboutContent[i].offsetHeight) - (scroll + aboutBox.height);
			if (diff >= 0) {
				diff = 0;
			}
			aboutSection.style.transform = 'translateY(' + diff + 'px)';
		} else {
			if (aboutObj.itemPos[aboutContent.length - 1] > scroll) {
				aboutSection.style.transform = 'translateY(0)';
			}
		}
	}
}

aboutDummy.parent.addEventListener('scroll', aboutScroll, false);
